import { Loader2 } from 'lucide-react';
import { POSTS } from '@/shared/data';
import { StoryRail } from './components/StoryRail';
import { PostCard } from './components/PostCard';

export function Home() {
  return (
    <div data-testid="instaflix-home">
      <StoryRail />
      <div>
        {POSTS.map((p) => (
          <PostCard key={p.id} postId={p.id} />
        ))}
      </div>
      {/* End-of-feed loader. Static demo never resolves it, but it
          communicates "more is on the way" when the user scrolls past
          the last post — matches the same affordance in Reelsflix. */}
      <div
        data-testid="instaflix-end-loader"
        className="flex flex-col items-center justify-center py-12 text-white/30"
      >
        <Loader2 className="w-7 h-7 animate-spin mb-3" />
        <div className="text-[10px] uppercase tracking-widest">Loading more</div>
      </div>
    </div>
  );
}
